import React, { useEffect, useState} from 'react';
import { useAuth } from '../utils/AuthContext';
import { Link, useNavigate, useLocation} from 'react-router-dom';
import { getCredit } from '../api/credit';
import { useParams } from "react-router-dom";
import { SidebarProvider } from "../components/SidebarContext";
import OrderHistory from '../components/OrderHistory';
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import SidebarToggle from '../components/SidebarToggle';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import "../css/Dashboard.css"

const Profile = () => {
  const { lang } = useParams();
  const { user, logout, loading } = useAuth();
  const [setlang, setLang] = useState("fa")
  const [infoCredit, setCredit] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const clearCookies = () => {document.cookie = "sessionid=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";}
  
  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, loading, navigate, location,lang]);
  
  const handleLogout = async () => {
    await logout();
    clearCookies();  
    navigate(`/${lang}/login`); 
  };

  useEffect(() => {
    if (!user) return;  
    getCredit(user)
      .then(res => {
        setCredit(res.data[-0]);  
      })
      .catch(err => {
        setCredit(null);  
      })
      .finally(() => {
      });
  }, [user]); 

  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) => 
    str
    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
    .replace(/\./g, '/');

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])
  

  if (loading) return <Loading />;  
  
  if (!user) {
    return (
      <>
        <div className="dashboard">
          <NavbarLog />
          {setlang === "en" ? 
          <div className="messaging-page">
            You must be logged in to view your profile<Link to={`/${lang}/login`}>login here</Link>!
          </div>
          :
          <div className="messaging-page">
          ! برای نمایش پروفایل لطفا <Link to={`/${lang}/login`}>از اینجا وارد شو</Link>!
          </div>
          }
          <Footer />
        </div>
      </>
    );
  }

  return (
    <>
      <NavbarLog />
      <SidebarProvider side={setlang}>
      <SidebarToggle />
      <div className={setlang==="en"?"dashboard-en":"dashboard-fa"}>
        {setlang==="en" && 
          <Sidebar />
        }
        <div className="main-content">

          

          {user.error ? (
            <div className="error-message">
              <p>{user.error}</p>
            </div>
          ) : (
            <>
              {/* Welcome Section */}
              {setlang === "en" ? 
              <div className="welcome-bar">
                <div className="welcome-text">
                  <h3>Welcome, {user.first_name}!</h3>
                  <p className="text-block">Email: {user.email}</p>
                  <p className="text-block">
                    <small>Joined: {toPersiDigits(dayjs.utc(user.date_joined).calendar("jalali").locale("fa").format("YYYY/MM/DD"))}</small> 
                  </p>
                </div>
                {user.profile_picture && (
                  <div className="welcome-picture">
                    <img src={user.profile_picture_url} alt="Profile" />
                  </div>
                )}
              </div>:
              <div className="welcome-bar">
                {user.profile_picture && (
                  <div className="welcome-picture">
                    <img src={user.profile_picture_url} alt="Profile" />
                  </div>
                )}
                <div className="welcome-text">
                  <h3>{user.first_name}, خوش آمدید</h3>
                  <p className="text-block">{user.email} :ایمیل</p>
                  <p className="text-block">
                   <small>تاریخ عضویت: {toPersiDigits(dayjs.utc(user.date_joined).calendar("jalali").locale("fa").format("YYYY/MM/DD"))} </small>
                  </p>
                </div>
              </div>
              }
  
              {/* Personal Information */}
              {setlang === "en" ? 
              <div className="info-section">
                <h2>Personal Information</h2>
                <div className="info-grid">
                  <p><strong>First Name:</strong> {user.first_name}</p>
                  <p><strong>Last Name:</strong> {user.last_name}</p>
                  <p><strong>Phone:</strong> {user.phone_number || "Not provided"}</p>
                  <p><strong>Email:</strong> {user.email}</p>
                </div>
              </div>:
              <div className="info-section">
                <h2>پروفایل کاربری</h2>
                <div className="info-grid">
                  <p>{user.phone_number || "Not provided"}<strong> :موبایل</strong></p>
                  <p>{user.first_name}<strong> :نام</strong></p>
                  <p> {user.email}<strong> :ایمیل</strong></p>
                  <p>{user.last_name}<strong> :نام خانوادگی</strong></p>
                </div>
              </div>
              }
  
              {/* Address Information */}
              {setlang === "en" ?
              <div className="info-section">
                <h2>Delivery Information</h2>
                <div className="info-grid">
                  <p><strong>Address:</strong> {user.address || "Not provided"}</p>
                  <p><strong>Zip Code:</strong> {user.zipcode || "Not provided"}</p>
                  <p><strong>City:</strong> {user.city || "Not provided"}</p>
                  <p><strong>Country:</strong> {user.country || "Not provided"}</p>
                  <p><strong> Province:</strong> {user.province || "Not provided"}</p>
                  <div className='info-sec-act'>
                    <Link to={`/${setlang}/profile/update`}>
                      <button>Update Profile</button>
                    </Link>
                  </div>
                </div>
              </div> :
              <div className="info-section">
                <h2>آدرس پستی</h2>
                <div className="info-grid">
                  <p>{user.country || "Not provided"}<strong> :کشور</strong></p>
                  <p>{user.address || "Not provided"}<strong> :آدرس</strong></p>
                  <p>{user.province || "Not provided"}<strong> :استان</strong></p>
                  <p>{user.city || "Not provided"}<strong> :منطقه</strong></p>
                  <p>{user.zipcode || "Not provided"}<strong> :کد پستی</strong></p>
                  <div className='info-sec-act'>
                    <Link to={`/${setlang}/profile/update`}>
                      <button>به روزرسانی پروفایل</button>
                    </Link>
                  </div>
                </div>
              </div>
              }

              {/* Account Information 
              {setlang === "en" ?
                <div>
                  {infoCredit && (
                  <div className="info-section">
                    <h2>Account Balance</h2>
                    <div className="info-grid">
                      <p><strong>Available Balance:</strong> {" IRT " + new Number(infoCredit.amount_available_IRT).toLocaleString() || "0 IRT"}</p>
                      <p><strong>Reserved Bids:</strong> {" IRT " + new Number(infoCredit.amount_reserved_IRT).toLocaleString() || "0 IRT"}</p>
                      <p><strong>Orders:</strong> {" IRT " + new Number(infoCredit.amount_blocked_IRT).toLocaleString() ||  "0 IRT"}</p>
                      <p><strong>Last Transaction</strong>{new Date(infoCredit.created_at).toLocaleDateString() ||  "No Transaction yet!"}</p>
                      <div className='info-sec-act'>
                        <Link to={`/${setlang}/profile/account/${4682}`}>
                          <button>Manage Account</button>
                        </Link>
                      </div>
                    </div>
                  </div>
                )} 
                </div> : 
                <div>
                  {infoCredit && (
                  <div className="info-section">
                    <h2>کیف پول</h2>
                    <div className="info-grid">
                      <p>{" IRT " + new Number(infoCredit.amount_reserved_IRT).toLocaleString() || "0 IRT"}<strong> :موجودی رزرو</strong></p>
                      <p>{" IRT " + new Number(infoCredit.amount_available_IRT).toLocaleString() || "0 IRT"}<strong> :موجودی باز</strong></p>
                      <p>{" IRT " + new Number(infoCredit.amount_blocked_IRT).toLocaleString() ||  "0 IRT"}<strong> :خرید</strong> </p>
                      <p>{new Date(infoCredit.created_at).toLocaleDateString() ||  "No Transaction yet!"}<strong> :آخرین تراکنش</strong></p>
                      <div className='info-sec-act'>
                        <Link to={`/${setlang}/profile/account/${4682}`}>
                          <button>واریز و برداشت</button>
                        </Link>
                      </div>
                    </div>
                  </div>
                )} 
                </div>
              }
              */}
              
              {/* Order History */}
              <div className="info-section">
                  <OrderHistory />
              </div>
              
              {/* Logout Button */}
              {setlang === "en" ?
              <button onClick={handleLogout} className="logout-btn">Log out</button>:
              <button onClick={handleLogout} className="logout-btn">خروج</button>
              }
            </>
          )}
        </div>
        {setlang==="fa" && 
          <Sidebar />
        }
      </div>

        </SidebarProvider>
        <Footer />
    </>
  );
};

export default Profile;